<template>
  <svg xmlns="http://www.w3.org/2000/svg" x="0" y="0" :width="size" :height="size" viewBox="0 0 24 24"
    :class="{'rotate':rotate}">
    <polygon :fill="fill" points="21.9,12 2.1,0.6 2.1,23.4"/>
  </svg>
</template>

<script>
export default {
  name: "Triangle",
  props: {
    fill: {
      default: 'currentColor',
      type: String,
    },
    size: {
      type: Number,
      default: 14,
    },
    rotate: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
svg {
  transition: all .15s;

  &.rotate {
    transform: rotateZ(90deg);
  }
}
</style>
